export var EXPANSION_INDICATOR_CLASS_PREFIX = 'ExpansionIndicator';
export var expansionIndicatorContainer = 'ExpansionIndicatorRoot';
export var expansionIndicatorContent = 'ExpansionIndicatorContent';
export var expansionIndicatorIcon = 'ExpansionIndicatorIcon';